export const setSelectedUser = function(state, user) {
  state.selectedUser = user
}

export const setSelectedGroup = function(state, group) {
  state.selectedGroup = group
}
export const setGroupDomainTypeOptions = function(state, value) {
  state.groupDomainTypeOptions = value
}
